import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import FaultySensorCell from '../../components/FaultySensorCell';

export const mapRequestDataToOptions = (response) => {
    const ALL = { label: 'ALL', value: 'all' };

    return {
        stations: [
            ALL,
            ...(response?.stations || []).map((s) => ({
                label: s.name,
                value: s.station_code,
                station_code: s.station_code, // optional extra info
            })),
        ],
        zones: [
            ALL,
            ...(response?.zones || []).map((z) => ({
                label: z.zone_name,
                value: z.zone_code,
            })),
        ],
        divisions: [
            ALL,
            ...(response?.divisions || []).map((d) => ({
                label: d.division_name,
                value: d.division_code,
            })),
        ],
        assetsTypeCode: [
            ALL,
            ...Array.from(new Set((response?.master || []).map((m) => m.asset_type_code))).map((code) => {
                const m = response.master.find((item) => item.asset_type_code === code);
                return {
                    label: m.asset_type_code,
                    value: m.asset_type_code,
                    sc: m.sc,
                };
            }),
        ],
        assetsType: [
            ALL,
            ...(response?.assetType || []).map((at) => ({
                label: at,
                value: at,
            })),
        ],
        assetsNumber: [
            ALL,
            ...(response?.master || []).map((m) => ({
                label: m.asset_number_code,
                value: m.asset_type_code,
                sc: m.sc,
            })),
        ],
        causes: [
            ALL,
            ...(response?.causes || []).map((c) => ({
                label: c.cause_detail ? `${c.cause_code} - ${c.cause_detail}` : c.cause_code,
                value: c.cause_code,
            })),
        ],
    };
};

export const sizePerPageList = [
    {
        text: '5',
        value: 5,
    },
    {
        text: '10',
        value: 10,
    },
    {
        text: '25',
        value: 25,
    },
    {
        text: '50',
        value: 50,
    },
];

export const alertSummaryColumns = [
    {
        Header: 'Sr Number',
        accessor: 'srNo',
    },
    {
        Header: 'Vendor Name',
        accessor: 'vcc',
    },
    {
        Header: 'Zone Code',
        accessor: 'zoneCode',
    },
    {
        Header: 'Division Code',
        accessor: 'divisionCode',
    },
    {
        Header: 'Station Code',
        accessor: 'stationCode',
    },
    {
        Header: 'Alert Type',
        accessor: 'alertType',
    },
    {
        Header: 'Asset Type',
        accessor: 'assetType',
    },
    {
        Header: 'Asset Number',
        accessor: 'assetNumber',
    },
    {
        Header: 'Cause Code',
        accessor: 'causeCode',
    },
    {
        Header: 'Total Count',
        accessor: 'totalCount',
    },
    {
        Header: 'True Count',
        accessor: 'trueCount',
    },
    {
        Header: 'Partially True Count',
        accessor: 'partiallyTrueCount',
    },
    {
        Header: '% of (True + Partially True) Alerts out of Total Alerts',
        accessor: 'resolvedPercentage',
    },
];

// export const alertLiveColumns = [
//     { Header: 'Sr Number', accessor: 'srNo' },

//     { Header: 'Zone', accessor: 'zoneCode' },
//     { Header: 'Division', accessor: 'divisionCode' },
//     { Header: 'Station', accessor: 'stationCode' },

//     { Header: 'Alert Type', accessor: 'alertType' },
//     { Header: 'Asset Type', accessor: 'assetType' },
//     { Header: 'Asset Number', accessor: 'assetNumber' },

//     { Header: 'Incidence Time', accessor: 'incidenceDate' },
//     { Header: 'Rectification Time', accessor: 'rectificationDate' },
//     { Header: 'Duration', accessor: 'incidenceDuration' },
//     {
//         Header: 'Faulty Sensor',
//         accessor: 'faultySensor',
//         Cell: ({ value }) => <div style={{ whiteSpace: 'pre-line' }}>{value}</div>,
//     },
//     { Header: 'Cause', accessor: 'causeCode' },

//     { Header: 'Feedback & Remarks', accessor: 'feedbackRemarks' },
// ];

export const getAlertLiveColumns = ({ userRole, handleFeedbackClick }) => [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Alert Type', accessor: 'alertType' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },

    { Header: 'Incidence Time', accessor: 'incidenceDate' },
    { Header: 'Rectification Time', accessor: 'rectificationDate' },
    { Header: 'Duration', accessor: 'incidenceDuration' },

    {
        Header: 'Faulty Sensor',
        accessor: 'faultySensor',
        Cell: ({ row }) => {
            const conditions = row.original.conditions;
            return (
                <FaultySensorCell
                    lines={
                        Array.isArray(conditions) && conditions.length > 0
                            ? conditions.map((cond) =>
                                  Object.entries(cond)
                                      .filter(([key]) => !['rated', 'threshold'].includes(key))
                                      .map(([key, value]) => `${key} : ${value}`)
                                      .join(' ')
                              )
                            : []
                    }
                />
            );
        },
    },

    { Header: 'Cause', accessor: 'causeCode' },

    {
        Header: 'Feedback & Remarks',
        accessor: 'feedbackRemarks',
        Cell: ({ row }) => {
            const note = row.original.notification;

            return (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {['T', 'PT', 'F', 'M'].map((status) => {
                            const isAllowed =
                                userRole === 'super admin' || userRole === 'admin' || userRole === 'Maintainer';

                            return (
                                <div
                                    key={status}
                                    style={{
                                        border: '3px solid black',
                                        borderRadius: '10px',
                                        width: '40px',
                                        height: '40px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: isAllowed ? 'pointer' : 'not-allowed',
                                        fontWeight: '600',
                                        opacity: isAllowed ? 1 : 0.5,
                                    }}
                                    onClick={() => {
                                        if (!isAllowed) return;
                                        handleFeedbackClick({ status, notification: note });
                                    }}>
                                    {status}
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        },
    },
];

// export const alertDetailsColumns = [
//     { Header: 'Sr Number', accessor: 'srNo' },

//     { Header: 'Vendor', accessor: 'vcc' },

//     { Header: 'Zone', accessor: 'zoneCode' },
//     { Header: 'Division', accessor: 'divisionCode' },
//     { Header: 'Station', accessor: 'stationCode' },

//     { Header: 'Alert Type', accessor: 'alertType' },
//     { Header: 'Asset Type', accessor: 'assetType' },
//     { Header: 'Asset Number', accessor: 'assetNumber' },
//     { Header: 'Alert Status', accessor: 'alertStatus' },

//     { Header: 'Cause', accessor: 'causeCode' },
//     { Header: 'Feedback', accessor: 'alertFeedback' },

//     { Header: 'Incidence Time', accessor: 'incidenceDate' },
//     { Header: 'Rectification Time', accessor: 'rectificationDate' },
//     { Header: 'Duration', accessor: 'incidenceDuration' },

//     { Header: 'Maintainer', accessor: 'maintainerName' },
//     { Header: 'Maintainer Designation', accessor: 'maintainerDesignation' },
//     { Header: 'Maintainer Mobile', accessor: 'maintainerMobile' },

//     { Header: 'Remarks', accessor: 'remarks' },
//     { Header: 'Add Comments', accessor: 'action', sort: false },
// ];

export const getAlertDetailsColumns = ({ userRole, auth, openModal, acknowledgeNotification, resolveNotification }) => [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Vendor', accessor: 'vcc' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Alert Type', accessor: 'alertType' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },
    { Header: 'Alert Status', accessor: 'alertStatus' },

    { Header: 'Cause', accessor: 'causeCode' },
    { Header: 'Feedback', accessor: 'alertFeedback' },

    { Header: 'Incidence Time', accessor: 'incidenceDate' },
    { Header: 'Rectification Time', accessor: 'rectificationDate' },
    { Header: 'Duration', accessor: 'incidenceDuration' },

    { Header: 'Maintainer', accessor: 'maintainerName' },
    { Header: 'Maintainer Designation', accessor: 'maintainerDesignation' },
    { Header: 'Maintainer Mobile', accessor: 'maintainerMobile' },

    {
        Header: 'Remarks',
        accessor: 'remarks',
        Cell: ({ row }) => {
            const field = row.original;
            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {field.remarks && (
                        <span
                            title={`Maintainer: ${field.remarks}`}
                            style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}>
                            <span style={{ fontWeight: 600, color: '#2c3e50', marginRight: '6px' }}>Maintainer:</span>
                            {field.remarks}
                        </span>
                    )}
                    {field.comments &&
                        Object.entries(field.comments).map(([role, comment]) =>
                            comment ? (
                                <span
                                    key={role}
                                    title={`${role}: ${comment}`}
                                    style={{
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}>
                                    <span style={{ fontWeight: 600, color: '#2c3e50', marginRight: '6px' }}>
                                        {role}:
                                    </span>
                                    {comment}
                                </span>
                            ) : null
                        )}
                </div>
            );
        },
    },

    {
        Header: 'Add Comments',
        accessor: 'action',
        sort: false,
        Cell: ({ row }) => {
            const field = row.original;
            const isAllowed = userRole !== 'Maintainer';

            return (
                <div className="d-flex justify-content-center align-items-center gap-1">
                    <Link
                        to="#"
                        className="action-icon"
                        style={{
                            pointerEvents: isAllowed ? 'auto' : 'none',
                            opacity: isAllowed ? 1 : 0.4,
                            cursor: isAllowed ? 'pointer' : 'not-allowed',
                        }}
                        onClick={() => {
                            if (!isAllowed) return;
                            openModal(field?.feedbackId);
                        }}>
                        <i className="mdi mdi-pencil"></i>
                    </Link>

                    <Link
                        to="#"
                        className="action-icon"
                        title="Acknowledge"
                        onClick={async () => {
                            let request = {
                                userId: auth.user.id,
                                note: field?.remarks,
                            };
                            const id = field?.notificationId;
                            await acknowledgeNotification(id, request);
                            toast.success('Acknowledged successfully');
                        }}>
                        <i className="mdi mdi-check-circle"></i>
                    </Link>

                    <Link
                        to="#"
                        className="action-icon"
                        title="Resolve"
                        onClick={async () => {
                            let request = { userId: auth.user.id };
                            const id = field?.notificationId;
                            await resolveNotification(id, request);
                            toast.success('Resolved successfully');
                        }}>
                        <i className="mdi mdi-check-all"></i>
                    </Link>
                </div>
            );
        },
    },
];

export const maintenanceModeColumns = [
    {
        Header: 'Sr Number',
        accessor: 'srNo',
    },
    {
        Header: 'Vendor Name',
        accessor: 'vcc',
    },
    {
        Header: 'Zone Code',
        accessor: 'zoneCode',
    },
    {
        Header: 'Division Code',
        accessor: 'divisionCode',
    },
    {
        Header: 'Station Code',
        accessor: 'stationCode',
    },
    {
        Header: 'Asset Type',
        accessor: 'assetType',
    },
    {
        Header: 'Asset Number',
        accessor: 'assetNumber',
    },
    {
        Header: 'Date and Time of Maintenance mode to activate',
        accessor: 'activate',
    },
    {
        Header: 'Date and Time of Maintenance mode to clear',
        accessor: 'clear',
    },
    {
        Header: 'Maintenance Mode',
        accessor: 'maintenanceMode',
    },
];

export const TelemetryLiveColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },
    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },
    { Header: 'Device ID', accessor: 'deviceId' },
    { Header: 'Internal ID', accessor: 'internalId' },
    { Header: 'Present Time', accessor: 'presentTime' },
    { Header: 'Action', accessor: 'action' },
];

export const TelemetryHistoryColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },
    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },
    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },
    { Header: 'Device ID', accessor: 'deviceId' },
    { Header: 'Internal ID', accessor: 'internalId' },
    // { Header: 'Parameter', accessor: 'parameter' },
    { Header: 'Action', accessor: 'action' },
];

export const rdpmshealthDetailsColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Total Sensors', accessor: 'totalSensors' },
    { Header: 'Faulty Sensors', accessor: 'faultySensors' },
    { Header: 'Total IoTs', accessor: 'totalIoTs' },

    { Header: 'Faulty IoTs', accessor: 'faultyIoTs' },
    { Header: 'Total Network', accessor: 'totalNetwork' },
    { Header: 'Faulty Network', accessor: 'faultyNetwork' },

    { Header: 'Total Station gateway', accessor: 'totalStationGateway' },
    { Header: 'Faulty Station gatway', accessor: 'faultyStationGatway' },
];

export const rdpmshealthLiveColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },

    { Header: 'Faulty Sensor description', accessor: 'faultySensorDescription' },
    { Header: 'Faulty IoT description', accessor: 'faultyIotDescription' },
    { Header: 'Faulty Network description', accessor: 'faultyNetworkDescription' },

    { Header: 'Faulty Station gateway', accessor: 'faultyStationGateway' },
];

export const rdpmshealthSummaryColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },

    { Header: 'Total Number Of Sensors', accessor: 'totalNumberOfSensors' },
    { Header: '% Availability of Sensors', accessor: 'availabilityOfSensors' },
    { Header: 'Total Number Of IoTs', accessor: 'totalNumberOfIoTs' },

    { Header: '% Availability Of IoTs', accessor: 'availabilityOfIoTs' },

    { Header: 'Total Number Of Network', accessor: 'totalNumberOfNetwork' },
    { Header: '% Availability of Network', accessor: 'availabilityOfNetwork' },
    { Header: 'Total Number Of Station Gateway', accessor: 'totalNumberOfStationGateway' },
    { Header: '% Availability of station gateway', accessor: 'availabilityOfStationGateway' },
];

export const equipmentRoomLiveColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Equipment Room Type', accessor: 'equipmentRoomType' },
    { Header: 'Temperature', accessor: 'temperature' },

    { Header: 'Humidity', accessor: 'humidity' },
    { Header: 'Relay Room opening (Open/Close)', accessor: 'relayRoomOpening' },
];

export const equipmentRoomHistoryColumns = [
    { Header: 'Sr No.', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Date & Time', accessor: 'dateTime' },
    { Header: 'Equipment Room Type', accessor: 'equipmentRoomType' },

    { Header: 'Temperature', accessor: 'temperature' },
    { Header: 'Humidity', accessor: 'humidity' },
    { Header: 'Relay Room opening (Open/Close)', accessor: 'relayRoomOpening' },
];

export const assetUtilizationColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },
    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Number', accessor: 'assetNumber' },

    { Header: 'Number of operations', accessor: 'numberOfOperations' },
];

export const assetsColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Vendor Code', accessor: 'vcc' },
    { Header: 'Vendor Name', accessor: 'vcn' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    { Header: 'Asset Type', accessor: 'assetType' },
    { Header: 'Asset Make', accessor: 'assetMake' },

    { Header: 'Total Count', accessor: 'totalCount' },
];

export const performanceColumns = [
    { Header: 'Sr Number', accessor: 'srNo' },

    { Header: 'Zone', accessor: 'zoneCode' },
    { Header: 'Division', accessor: 'divisionCode' },
    { Header: 'Station', accessor: 'stationCode' },

    {
        Header: '% of (True + Partially True) Failure Alerts out of total Failure Alerts generated',
        accessor: 'failure',
    },
    {
        Header: '% of (True + Partially True) Predictive Alerts out of total Predictive Alerts generated',
        accessor: 'predective',
    },
    {
        Header: '% of (True + Partially True) Failure Alerts by RDPMS out of total actual failures occurred at station',
        accessor: 'actualAlert',
    },
];

// ============================================================================
// GATE / BOOLEAN PARAM MERGE CONFIG
// ----------------------------------------------------------------------------
export const GATE_MERGE_ASSET_TYPES = ['ELC', 'MLC'];

export const GATE_PAIR_CONFIGS = [
    {
        keys: ['gate_open', 'gate_closed'],
        label: 'Gate Open/Closed',
        display: {
            gate_open: { true: 'Open', false: 'Closed' },
            gate_closed: { true: 'Closed', false: 'Open' },
        },
    },
    {
        keys: ['gate_locked', 'gate_unlocked'],
        label: 'Gate Locked/Unlocked',
        display: {
            gate_locked: { true: 'Locked', false: 'Unlocked' },
            gate_unlocked: { true: 'Unlocked', false: 'Locked' },
        },
    },
    {
        keys: ['gate_opening', 'gate_closing'],
        label: 'Gate Opening/Closing',
        display: {
            gate_opening: { true: 'Opening', false: 'Closing' },
            gate_closing: { true: 'Closing', false: 'Opening' },
        },
    },
];

// Single boolean params ke custom labels (pair nahi hai, akela param hai)
// Naya boolean param aaye to bas yahan entry add kar do
export const SINGLE_BOOL_LABELS = {
    power_available: { true: 'Available', false: 'Not Available' },
};

// boolean values JSX me directly render nahi hote (blank dikhte hai),
// isliye string me convert karna zaroori hai
export const formatParamValue = (val, paramName) => {
    if (val === undefined || val === null || val === '') return '-';

    // param-specific custom label agar defined hai to wo use karo
    const customLabels = SINGLE_BOOL_LABELS[paramName];
    if (customLabels && (val === true || val === false || val === 'true' || val === 'false')) {
        return customLabels[String(val)];
    }

    // default boolean handling
    if (typeof val === 'boolean') return val ? 'True' : 'False';

    return val;
};

// ============================================================================
// LIVE PAGE ke liye
// rowData.parameters = [{ name, value }, ...]  (single row, ek hi timestamp)
// ============================================================================
export const buildGateMergedLiveRowData = (rowData) => {
    if (!rowData || !GATE_MERGE_ASSET_TYPES.includes(rowData.assetType)) {
        return rowData;
    }

    const originalParams = rowData.parameters || [];
    const paramMap = new Map(originalParams.map((p) => [p.name, p.value]));
    const consumedKeys = new Set();
    const mergedParameters = [];

    originalParams.forEach((p) => {
        if (consumedKeys.has(p.name)) return;

        const pairConfig = GATE_PAIR_CONFIGS.find((cfg) => cfg.keys.includes(p.name));

        if (pairConfig) {
            pairConfig.keys.forEach((k) => consumedKeys.add(k));

            let mergedValue = '-';
            for (const key of pairConfig.keys) {
                if (paramMap.has(key)) {
                    const rawVal = paramMap.get(key);
                    mergedValue = pairConfig.display[key][rawVal] ?? rawVal;
                    break;
                }
            }

            mergedParameters.push({ name: pairConfig.label, value: mergedValue });
        } else {
            consumedKeys.add(p.name);
            mergedParameters.push({ name: p.name, value: formatParamValue(p.value, p.name) });
        }
    });

    return {
        ...rowData,
        parameters: mergedParameters,
    };
};

// ============================================================================
// HISTORY PAGE ke liye
// rowData.paramKeys = ['gate_open', ...]
// rowData.rows = [{ dateTime, values: ['false', 'true', ...] }, ...]  (multi-row)
// ============================================================================
export const buildGateMergedHistoryRowData = (rowData) => {
    if (!rowData || !GATE_MERGE_ASSET_TYPES.includes(rowData.assetType)) {
        return rowData;
    }

    const originalParamKeys = rowData.paramKeys || [];
    const consumedKeys = new Set();
    const displayParamKeys = [];
    const columnPlan = [];

    originalParamKeys.forEach((key) => {
        if (consumedKeys.has(key)) return;

        const pairConfig = GATE_PAIR_CONFIGS.find((cfg) => cfg.keys.includes(key));

        if (pairConfig) {
            pairConfig.keys.forEach((k) => consumedKeys.add(k));
            displayParamKeys.push(pairConfig.label);
            columnPlan.push({ type: 'merged', config: pairConfig });
        } else {
            consumedKeys.add(key);
            displayParamKeys.push(key);
            columnPlan.push({ type: 'plain', key });
        }
    });

    const displayRows = (rowData.rows || []).map((row) => {
        const values = columnPlan.map((plan) => {
            if (plan.type === 'plain') {
                const idx = originalParamKeys.indexOf(plan.key);
                return formatParamValue(row.values[idx], plan.key);
            }

            for (const key of plan.config.keys) {
                const idx = originalParamKeys.indexOf(key);
                const rawVal = row.values[idx];
                if (rawVal !== undefined && rawVal !== '-') {
                    return plan.config.display[key][rawVal] || rawVal;
                }
            }
            return '-';
        });

        return { dateTime: row.dateTime, values };
    });

    return {
        ...rowData,
        paramKeys: displayParamKeys,
        rows: displayRows,
    };
};
